import { FC } from 'react';
import { DayPicker } from 'react-day-picker';
import { enUS, ru } from 'date-fns/locale';
import './styles.css';
import { useTranslation } from "react-i18next";
import { Colors } from '@brg/ui';

const css = `
    .rdp {
        --rdp-cell-size: 24px; 
        padding: 16px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
        border-radius: 0;
    }
  .rdp-day_outside {
     color: ${Colors.galBlack21};
  }
  .rdp-caption_label {
    padding: 0!important;    
    text-transform: capitalize;
    // margin-left: calc(var(--rdp-cell-size) / 6);
    font-size: 17px;
    line-height: 22px;
  }
  .rdp-caption {
     margin-bottom: 16px;
  }
      .rdp-head_row, .rdp-row {
        column-gap: 4.39px;
    }
  .rdp-head_cell, .rdp-cell, .rdp-caption_label {
      font-size: 13px;
      line-height: 16px;
     letter-spacing: -0.02em;
     height: 56px!important;
        height: 23.5px!important;
        font-weight: 600;
  }
    .rdp-caption_label {
       font-size: 17px;
      line-height: 22px;
  }
  .rdp-head_cell {
     text-transform: lowercase;
     height: 24px !important;
  }
  .rdp-nav_icon {
      width: 16px;
      height: 16px;
  }
  .rdp-tbody {
      margin-top: 11px;
      row-gap: 4px;
  }
  .rdp-day_today:not(.rdp-day_outside) {
    font-weight: normal;
    // background: #E7E7E7;
    color: #E36650;
  }
  button:focus {
    outline: none;
  }
  .rdp-button:active {
    color: inherit;
    background-color: transparent!important;
  }
    .rdp-day {
        height: 24px;
    }
    .rdp-nav_button {
        width: 22px;
        height: 22px;
    }

  .rdp-day_selected:not([disabled]) {
    color: ${Colors.geoWhite100}!important;
    background: ${Colors.galBlack47}!important;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  }
  .rdp-day_selected:not([disabled]):hover {
    color: ${Colors.geoWhite100}!important;
  }

  .rdp-button:not([disabled]):hover {
    color: ${Colors.galBlack73};
  }


  @media all {
    .rdp-day_outside:not([disabled]):hover {
        color: ${Colors.galBlack61};
    }
  }

  @media(max-width: 992px) {
  }

  @media(max-width: 743px) {

    .rdp {
        --rdp-cell-size: 9.5vw;
        padding: 3.5vw;
    }
    .rdp-button {
        height: 100%
    }
    .rdp-head_row, .rdp-row {
        column-gap: 2.3vw;
    }
    .rdp-caption {
        margin-bottom: 5vw;
    }
    .rdp-tbody {
        margin-top: 3vw;
        row-gap: 1.5vw;
    }
    .rdp-nav_icon {
        width: 5vw;
        height: 5vw;
    }
    .rdp-nav_button {
        width: 7vw;
        height: 7vw;
    }
    .rdp-head_cell, .rdp-cell, .rdp-caption_label {
        font-size: 5vw;
        font-style: normal;
        font-weight: 600;
        line-height: 6.8vw;
        height: 8vw!important;
    }
    .rdp-caption_label {
        margin-left: 2px;
    }
}
`;

interface CalendarComponentProps {
    eventsDate?: Date[],
    newDate?: Date | undefined,
    setNewDate: (val: Date | undefined) => void,
}

export const CalendarComponent: FC<CalendarComponentProps> = (props) => {

    const { i18n } = useTranslation();
    const {
        eventsDate = [],
        newDate,
        setNewDate
    } = props;

    return (<><style>{css}</style><DayPicker
        mode="single"
        weekStartsOn={1}
        fixedWeeks
        modifiers={{ withEvents: eventsDate }}
        modifiersStyles={{ withEvents: { color: '#C64839', fontWeight: 600 } }}
        selected={newDate}
        onSelect={setNewDate}
        locale={i18n.language === 'ru' ? ru : enUS}
        showOutsideDays
    />
    </>)
}
import { FC } from 'react';
import { DayPicker } from 'react-day-picker';
import { enUS, ru } from 'date-fns/locale';
import './styles.css';
import { useTranslation } from "react-i18next";
import { Colors } from '@brg/ui';

const css = `
    .rdp {
        --rdp-cell-size: 24px; 
        padding: 16px;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
        border-radius: 0;
    }
  .rdp-day_outside {
     color: ${Colors.galBlack21};
  }
  .rdp-caption_label {
    padding: 0!important;    
    text-transform: capitalize;
    // margin-left: calc(var(--rdp-cell-size) / 6);
    font-size: 17px;
    line-height: 22px;
  }
  .rdp-caption {
     margin-bottom: 16px;
  }
      .rdp-head_row, .rdp-row {
        column-gap: 4.39px;
    }
  .rdp-head_cell, .rdp-cell, .rdp-caption_label {
      font-size: 13px;
      line-height: 16px;
     letter-spacing: -0.02em;
     height: 56px!important;
        height: 23.5px!important;
        font-weight: 600;
  }
    .rdp-caption_label {
       font-size: 17px;
      line-height: 22px;
  }
  .rdp-head_cell {
     text-transform: lowercase;
     height: 24px !important;
  }
  .rdp-nav_icon {
      width: 16px;
      height: 16px;
  }
  .rdp-tbody {
      margin-top: 11px;
      row-gap: 4px;
  }
  .rdp-day_today:not(.rdp-day_outside) {
    font-weight: normal;
    // background: #E7E7E7;
    color: #E36650;
  }
  button:focus {
    outline: none;
  }
  .rdp-button:active {
    color: inherit;
    background-color: transparent!important;
  }
    .rdp-day {
        height: 24px;
    }
    .rdp-nav_button {
        width: 22px;
        height: 22px;
    }

  .rdp-day_selected:not([disabled]) {
    color: ${Colors.geoWhite100}!important;
    background: ${Colors.galBlack47}!important;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);
  }
  .rdp-day_selected:not([disabled]):hover {
    color: ${Colors.geoWhite100}!important;
  }

  .rdp-button:not([disabled]):hover {
    color: ${Colors.galBlack73};
  }


  @media all {
    .rdp-day_outside:not([disabled]):hover {
        color: ${Colors.galBlack61};
    }
  }

  @media(max-width: 992px) {
  }

  @media(max-width: 743px) {

    .rdp {
        --rdp-cell-size: 9.5vw;
        padding: 3.5vw;
    }
    .rdp-button {
        height: 100%
    }
    .rdp-head_row, .rdp-row {
        column-gap: 2.3vw;
    }
    .rdp-caption {
        margin-bottom: 5vw;
    }
    .rdp-tbody {
        margin-top: 3vw;
        row-gap: 1.5vw;
    }
    .rdp-nav_icon {
        width: 5vw;
        height: 5vw;
    }
    .rdp-nav_button {
        width: 7vw;
        height: 7vw;
    }
    .rdp-head_cell, .rdp-cell, .rdp-caption_label {
        font-size: 5vw;
        font-style: normal;
        font-weight: 600;
        line-height: 6.8vw;
        height: 8vw!important;
    }
    .rdp-caption_label {
        margin-left: 2px;
    }
}
`;

interface CalendarComponentProps {
    eventsDate?: Date[],
    newDate?: Date | undefined,
    setNewDate: (val: Date | undefined) => void,
}

export const CalendarComponent: FC<CalendarComponentProps> = (props) => {

    const { i18n } = useTranslation();
    const {
        eventsDate = [],
        newDate,
        setNewDate
    } = props;

    return (<><style>{css}</style><DayPicker
        mode="single"
        weekStartsOn={1}
        fixedWeeks
        modifiers={{ withEvents: eventsDate }}
        modifiersStyles={{ withEvents: { color: '#C64839', fontWeight: 600 } }}
        selected={newDate}
        onSelect={setNewDate}
        locale={i18n.language === 'ru' ? ru : enUS}
        showOutsideDays
    />
    </>)
}
